module.exports = __webpack_public_path__ + "static/media/meetupok.d16d8f43.png";